$(document).on("click", "#admin-auth-btn", function (e1) {
    var butt = $(this);
    if (butt.hasClass('disabled')) {
        return;
    }
    butt.addClass("disabled");
    butt.find(".fa-sign-in-alt").hide();
    butt.find(".fa-spinner").show();
    let form = $(this).closest('form');
    form.off("submit");
    form.on("submit", function (e2) {
        let formData = new FormData(this);
        e1.preventDefault();
        e2.preventDefault();

        let formUrl = form.attr("action");

        grecaptcha.ready(function () {
            grecaptcha.execute('6LciuZkbAAAAAHfWXBT2UDt3A102jMLaIM0kGTmA', {action: 'login'}).then(function (token) {
                formData.append('token', token);
                formData.append('action', 'login');
                $.nette.ajax({
                    url: formUrl,
                    data: formData,
                    type: 'POST',
                    processData: false,
                    contentType: false,
                    off: {
                        snippets: true
                    }
                }).done(function (payload) {
                    if (payload.error) {
                        toastr.warning(payload.error);
                    }
                    butt.find(".fa-spinner").hide();
                    butt.find(".fa-sign-in-alt").show();
                    butt.removeClass('disabled');
                });
            });
        });
    });
});